export const tabs = [
  { title: 'Транспорт', label: 'main' },
  { title: 'Грузы', label: 'cargoes' },
  { title: 'Файлы и комментарии', label: 'filesComments' }
]
